import { SecurityTypes } from "./variables";

export const instrumentDetailSecurityTypeList = [
    {
        apiField: "Opening Date",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Deletion Date",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Deletion Reason",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "FISN",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "SIX FISN",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "FISN Securities Abbreviation",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "FISN Allocation Type",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Instrument Product Brand",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Redenomination Method",
        securityTypes: [
            SecurityTypes.EQUITY
        ]
    },
    {
        apiField: "Original Nominal Amount",
        securityTypes: [
            SecurityTypes.EQUITY
        ]
    },
    {
        apiField: "Original Nominal Currency",
        securityTypes: [
            SecurityTypes.EQUITY
        ]
    },
    {
        apiField: "Instrument Legal Form",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Monitoring Restriction",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Original Issuer",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Original Issuer / Short Name",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Original Issuer / Long Name",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Original Issuer / GK",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Original Issuer / LEI",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Main Underlying Asset Class",
        securityTypes: [
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Second Level Main Underlying Asset Class",
        securityTypes: [
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Callable",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Puttable",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Amortization",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Partly Paid Issue",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Extension By Issuer",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Extension By Holder",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Conversion By Holder",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Conversion By Issuer",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Repayments In Other Currencies",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Reopening Clause",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Covered Warrant",
        securityTypes: [
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Interest Due End Of Month",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Without Physical Coupon",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Callable For Tax Reasons",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Notional Amount",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Country Of Applicable Law",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Currency Risk Hedged",
        securityTypes: [
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Autocall Possible",
        securityTypes: [
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Collateral Secured Instrument",
        securityTypes: [
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Distributions In Other Currencies",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Nominal Reduction",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Seniority",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Vote Carrying",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Certificate",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.DEBT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
        ]
    },
    {
        apiField: "Certificate Type",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.DEBT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
        ]
    },
    {
        apiField: "ICMA Regulated",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.DEBT,
        ]
    },
    {
        apiField: "Combined Instrument",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Right Type",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Exchangeable",
        securityTypes: [
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Inflation Protected",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Insurance Linked",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Overall Conversion Or Exercise Period Date From",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Overall Conversion Or Exercise Period Date To",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Next Cash Dividend",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Next Cash Dividend / Announcement Date",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Next Cash Dividend / Ex Dividend Date",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Next Cash Dividend / Payment Date",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Next Cash Dividend / Payment Status",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Next Cash Dividend / Gross Amount",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Next Cash Dividend / Gross Amount Currency",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Next Cash Dividend / Dividend Type",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Next Cash Dividend / Dividend Payment Frequency",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Previous Cash Dividend",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Previous Cash Dividend / Announcement Date",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Previous Cash Dividend / Ex Dividend Date",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Previous Cash Dividend / Payment Date",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Previous Cash Dividend / Payment Status",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Previous Cash Dividend / Gross Amount",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Previous Cash Dividend / Gross Amount Currency",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Previous Cash Dividend / Dividend Type",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Previous Cash Dividend / Dividend Payment Frequency",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "New Instruments",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "New Instruments / Short Name",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "New Instruments / Valor",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "New Instruments / ISIN",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Outstanding Capital",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Outstanding Number Of Instruments",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Outstanding Capital Effective Date",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Issued Capital",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Issued Number Of Instruments",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Issued Capital Effective Date",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Treasury Stock",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Treasury Stock Number Of Instruments",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Treasury Stock Effective Date",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Total Number Of Voting Rights",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Total Number Of Voting Rights Effective Date",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Free Float Number Of Instruments",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Free Float Effective Date",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Equity Type",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Preferred Dividend Type",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Number Of Voting Rights Per Share",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Legal Maturity Date",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Par Value Type",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Stated Value",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Stated Value Currency",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Dividend Reinvestment Plan",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Current Dividend Payment Frequency",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Earnings Type",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Earnings Whole Term Type",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Subject To Withholding Tax",
        securityTypes: [
            SecurityTypes.EQUITY
        ]
    },
    {
        apiField: "Capital Protection",
        securityTypes: [
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Fund Type",
        securityTypes: [
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Closed End Fund",
        securityTypes: [
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Fund Distribution Policy",
        securityTypes: [
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Fund Performance Currency",
        securityTypes: [
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE
        ]
    },
    {
        apiField: "Commodity Type",
        securityTypes: [
            SecurityTypes.COMMODITY
        ]
    },
    {
        apiField: "Commodity Category",
        securityTypes: [
            SecurityTypes.COMMODITY
        ]
    },
    {
        apiField: "Commodity Name",
        securityTypes: [
            SecurityTypes.COMMODITY
        ]
    },
    {
        apiField: "Commodity Form",
        securityTypes: [
            SecurityTypes.COMMODITY
        ]
    },
    {
        apiField: "Commodity Number Of Units",
        securityTypes: [
            SecurityTypes.COMMODITY
        ]
    },
    {
        apiField: "Commodity Unit Type",
        securityTypes: [
            SecurityTypes.COMMODITY
        ]
    },
    {
        apiField: "Commodity Quality Level",
        securityTypes: [
            SecurityTypes.COMMODITY
        ]
    },
    {
        apiField: "Commodity Features",
        securityTypes: [
            SecurityTypes.COMMODITY
        ]
    },
    {
        apiField: "Combined Transaction Type",
        securityTypes: [
            SecurityTypes.COMMODITY,
            SecurityTypes.DEBT,
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION,
            SecurityTypes.EQUITY,
            SecurityTypes.INVESTMENT_TRUST_UNIT_SHARE,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Expiration Time",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Accelerated Expiration Date",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Delivery Last Date",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Exchange Generation Number",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Exchange Version Number",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Contract Specification",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Contract Specification / Short Name",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Contract Specification / Valor",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Contract Specification / ISIN",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Underlying Reference Market",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Underlying Reference Market / Short Name",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Underlying Reference Market / Long Name",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Underlying Reference Market / BC",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Underlying Reference Market / MIC",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Contractual Settlement Date",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Position Limit",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Contract Date Year",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Contract Date Month",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Contract Date Day",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Original Option Strike Price",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Strike Price Representation",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Contract Size Type",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Contract Quantity Deliverable",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Contract Frequency",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Settlement Type",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Cash Compensation Amount",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Cash Compensation Currency",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Standard Contract",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "ETD Successor Instrument",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "ETD Successor Instrument / Short Name",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "ETD Successor Instrument / Valor",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "ETD Successor Instrument / Transferred ISIN",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "ETD Successor Instrument / Transferred ISIN Status",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "ETD Successor Instrument / Transferred ISIN Date From",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "ETD Successor Instrument / Transferred ISIN Date To",
        securityTypes: [
            SecurityTypes.ETD,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Dated Date",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "First Coupon Date",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Coupon Capitalization",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Delayed Interest Payment In Months",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Delayed Interest Payment Day",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Day Count Basis",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Day Count Basis Label",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Business Day Convention",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Coupon Period Adjustment",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Coupon Payment Frequency",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Coupon Payment Frequency Time Unit",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Irregular First Coupon",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Irregular Last Coupon",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Redemption Ratio",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Redemption Amount",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Redemption Amount Currency",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Next Coupon",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Next Coupon / Significant Date",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Next Coupon / Payment Date",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Next Coupon / Payment Status",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Next Coupon / Gross Rate",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Next Coupon / Entitlement Period Start Date",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Next Coupon / Entitlement Period End Date",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Previous Coupon",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Previous Coupon / Significant Date",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Previous Coupon / Payment Date",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Previous Coupon / Payment Status",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Previous Coupon / Gross Rate",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Previous Coupon / Entitlement Period Start Date",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Previous Coupon / Entitlement Period End Date",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT
        ]
    },
    {
        apiField: "Debt Adjustment Factors",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Debt Adjustment Factors / Type",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Debt Adjustment Factors / Factor",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Debt Adjustment Factors / Due Date",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Debt Adjustment Factors / Valid Until Date",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Nominal Inflation Protected",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Nominal Inflation Protected / Index Ratio",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Nominal Inflation Protected / Due Date",
        securityTypes: [
            SecurityTypes.DEBT
        ]
    },
    {
        apiField: "Instrument Dependencies",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.DEBT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Instrument Dependencies / Short Name",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.DEBT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Instrument Dependencies / Valor",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.DEBT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Instrument Dependencies / ISIN",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.DEBT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Instrument Dependencies / Dependency Type",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.DEBT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Instrument Dependencies / Number Of Dependent Instruments",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.DEBT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Instrument Dependencies / Number Of Independent Instruments",
        securityTypes: [
            SecurityTypes.EQUITY,
            SecurityTypes.DEBT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT,
            SecurityTypes.ETD_CONTRACT_SPECIFICATION
        ]
    },
    {
        apiField: "Next Call Date",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    },
    {
        apiField: "Next Put Date",
        securityTypes: [
            SecurityTypes.DEBT,
            SecurityTypes.STRUCTURED_PRODUCT,
            SecurityTypes.LEVERAGED_PRODUCT_SUBSCRIPTION_RIGHT
        ]
    }
]